import { render, staticRenderFns } from "./ChatMsgQuey.vue?vue&type=template&id=6ab5484e&scoped=true"
import script from "./ChatMsgQuey.vue?vue&type=script&lang=js"
export * from "./ChatMsgQuey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab5484e",
  null
  
)

export default component.exports